// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FlagTwoToneSvg from "@ant-design/icons-svg/es/asn/FlagTwoTone";
import AntdIcon from '../components/AntdIcon';

var FlagTwoTone = function FlagTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FlagTwoToneSvg
  }));
};

FlagTwoTone.displayName = 'FlagTwoTone';
export default React.forwardRef(FlagTwoTone);